import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment, { Moment } from 'moment';

import PageHeader from 'retired/PageHeader';
import PeriodSwitcher from 'retired/PeriodSwitcher';
import { PERIODS_DEFINITION } from 'retired/PeriodSwitcher/periodsDefinition';
import { selectUser, selectOrganization } from 'entities/user/selectors';
import { Features } from 'utils/features';

import { getSingleReport, SingleBoxInterface } from '../ReportsBasicPage/reportsDefinition';
import { Privileges } from '../../utils/privileges';

import Monthly from './monthly';
import Quarterly from './quarterly';
import SingleReportRow from './singleReportRow';

const ReportsDetailsPage: React.FC<{}> | null = () => {
  const history = useHistory();
  const { family, type } = useParams();
  const reportType: SingleBoxInterface | null = getSingleReport(family, type);
  const organization = useSelector(selectOrganization);
  const user = useSelector(selectUser);
  const organizationCreatedAt: Moment | null = organization
    ? moment.utc(organization.createdAt)
    : null;

  const [activePeriod, setActivePeriod] = useState<PERIODS_DEFINITION>(PERIODS_DEFINITION.MONTH);

  if (
    user &&
    (!user.hasFeature(Features.REPORTS) ||
      !(
        user.hasPrivilege(Privileges.REPORTS_VIEW) ||
        user.hasPrivilege(Privileges.REPORTS_VIEW_RESTRICTED)
      ))
  ) {
    history.replace('/');
  }

  if (!organizationCreatedAt) {
    return null;
  }

  if (!reportType) {
    history.push('/reports');
    return null;
  } else {
    return (
      <>
        <Helmet title={reportType.title} />

        <PageHeader
          title={reportType.title}
          subtitle={reportType.text}
          onArrowClick={(): void => {
            history.push('/reports');
          }}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 20,
          }}
        >
          <PeriodSwitcher active={activePeriod} onClick={setActivePeriod} reportType={reportType} />
        </div>

        <div>
          <div
            style={{
              height: 80,
              background: '#FAFAFC',
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 12,
              padding: '0 30px',
              borderBottom: `1px solid #EBEEF0`,
            }}
          >
            <span style={{ width: 200 }}>Date</span>
            <span style={{ flexGrow: 1 }}>Description</span>
            <span style={{ width: 150 }}>Action</span>
          </div>
          {activePeriod === PERIODS_DEFINITION.MONTH && (
            <Monthly reportType={reportType} organizationCreatedAt={organizationCreatedAt} />
          )}
          {activePeriod === PERIODS_DEFINITION.QUARTER && (
            <Quarterly reportType={reportType} organizationCreatedAt={organizationCreatedAt} />
          )}
          {activePeriod === PERIODS_DEFINITION.YEAR && (
            <div
              style={{
                background: 'white',
                borderBottomLeftRadius: 20,
                borderBottomRightRadius: 20,
              }}
            >
              {Array.from(Array(moment().year() - (organizationCreatedAt.year() - 1)).keys())
                .map((a) => a + organizationCreatedAt.year())
                .reverse()
                .map((item: number) => (
                  <div
                    style={{
                      margin: '0 30px',
                    }}
                    key={item}
                  >
                    <SingleReportRow
                      shortText={`${item}`}
                      longText={`${item}_${reportType.title.split(' ').join('_')}`}
                      type={reportType.type}
                      fileName={`${item}_${reportType.title.split(' ').join('_')}.xlsx`}
                      from={moment.utc([item, 0, 1]).valueOf()}
                      to={moment.utc([item + 1, 0, 1, 0, 0, 0]).valueOf()}
                      comparison={reportType.comparison}
                      entity={reportType.entity}
                      period={PERIODS_DEFINITION.YEAR}
                    />
                  </div>
                ))}
            </div>
          )}

          {activePeriod === PERIODS_DEFINITION.ALL && (
            <div
              style={{
                margin: '0 30px',
              }}
            >
              <SingleReportRow
                shortText="All Time"
                longText={`All_Time_${reportType.title.split(' ').join('_')}`}
                type={reportType?.type}
                fileName={`All_Time_${reportType.title.split(' ').join('_')}.xlsx`}
                entity={reportType.entity}
              />
            </div>
          )}
        </div>
      </>
    );
  }
};

export default ReportsDetailsPage;
